import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import {
  ROUTES,
  WORKSPACE_ROLE_LEVEL,
  WORKSPACE_ROLE_PERMISSION
} from '../../common/constants';
import AccessControl from '../../components/AccessControl';
import AddEditWorkspaceUsers from './AddEditWorkspaceUsers';
import WorkspaceUsers from './WorkspaceUsers';

const WorkspaceUsersWrapper = () => {
  return (
    <Switch>
      <Route
        exact
        path={ROUTES?.WORKSPACE_USERS}
        render={(props) => (
          <AccessControl
            modulePermissions={[
              {
                moduleKey: WORKSPACE_ROLE_PERMISSION.WORKSPACE_USER_MANAGEMENT,
                allowedPermissions: [
                  WORKSPACE_ROLE_LEVEL.VIEW,
                  WORKSPACE_ROLE_LEVEL.EDIT,
                  WORKSPACE_ROLE_LEVEL.DELETE
                ]
              }
            ]}
          >
            <WorkspaceUsers {...props} />
          </AccessControl>
        )}
      />
      <Route
        exact
        path={`${ROUTES?.WORKSPACE_USERS}/add`}
        render={(props) => (
          <AccessControl
            modulePermissions={[
              {
                moduleKey: WORKSPACE_ROLE_PERMISSION.WORKSPACE_USER_MANAGEMENT,
                allowedPermissions: [
                  WORKSPACE_ROLE_LEVEL.EDIT,
                  WORKSPACE_ROLE_LEVEL.DELETE
                ]
              }
            ]}
          >
            <AddEditWorkspaceUsers {...props} />
          </AccessControl>
        )}
      />
      <Route
        exact
        path={`${ROUTES?.WORKSPACE_USERS}/:userId/edit`}
        render={(props) => (
          <AccessControl
            modulePermissions={[
              {
                moduleKey: WORKSPACE_ROLE_PERMISSION.WORKSPACE_USER_MANAGEMENT,
                allowedPermissions: [
                  WORKSPACE_ROLE_LEVEL.VIEW,
                  WORKSPACE_ROLE_LEVEL.EDIT,
                  WORKSPACE_ROLE_LEVEL.DELETE
                ]
              }
            ]}
          >
            <AddEditWorkspaceUsers {...props} />
          </AccessControl>
        )}
      />
      <Route
        exact
        path={`${ROUTES?.WORKSPACE_USERS}/:userId`}
        render={() => <Redirect to={ROUTES?.WORKSPACE_USERS} />}
      />
    </Switch>
  );
};

export default WorkspaceUsersWrapper;
